import React from 'react';

class BoxItemListItem extends React.Component {
    render() {
        const {item, pos} = this.props;
        const {barcodeNumber, orderNumber, labelDetails, boxed_at} = Object.assign({}, item);
        const {partnerTrackingNumber} = Object.assign({}, labelDetails);
        const boxedAtText = boxed_at && new Date(boxed_at).toLocaleString('en-GB');

        return (
            <tr className="BoxItemListItem">
                <td>{pos}</td>
                <td className="text-primary">#{barcodeNumber}</td>
                <td>{orderNumber}</td>
                <td>{partnerTrackingNumber}</td>
                <td>{boxedAtText}</td>
            </tr>
        );
    }
}

export default BoxItemListItem;
